import styled from "styled-components";
import { SearchOrder } from "./types";

export const ProgressBarContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== "isMobile",
})<{ isMobile?: boolean }>`
  width: ${({ isMobile }) => (isMobile ? "100%" : "auto")};
  min-width: 0;
  margin-top: ${({ isMobile }) => (isMobile ? "20px" : 0)};
  margin-left: 0;
  gap: ${({ theme }) => theme.spacing(2)};
  flex: 1;
  flex-direction: column;
  display: flex;
`;

export const ProgressHeader = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== "isMobile",
})<{ isMobile?: boolean }>`
  gap: ${({ theme }) => theme.spacing(2)};
  justify-content: space-between;
  align-items: ${({ isMobile }) => (isMobile ? "stretch" : "center")};
  flex-direction: ${({ isMobile }) => (isMobile ? "column" : "row")};
  display: flex;
`;

export const SearchStatus = styled.h2`
  margin: 0;
  color: ${({ theme }) => theme.colors.mediumBlue};
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes.xl};
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  line-height: 1.2;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    font-size: ${({ theme }) => theme.fontSizes.lg};
  }
`;

export const SegmentedControl = styled.div`
  padding: ${({ theme }) => theme.spacing(0.5)};
  border-radius: ${({ theme }) => theme.spacing(3)};
  background-color: ${({ theme }) => theme.colors.lightGray};
  grid-template-columns: repeat(3, minmax(0, 1fr));
  display: grid;
`;

export const SegmentButton = styled.button.withConfig({
  shouldForwardProp: (prop) => !["isActive", "order"].includes(prop),
})<{ isActive?: boolean; order: SearchOrder }>`
  min-height: ${({ theme }) => theme.spacing(5)};
  padding: ${({ theme }) => theme.spacing(0.75)}
    ${({ theme }) => theme.spacing(1.5)};
  gap: ${({ theme }) => theme.spacing(0.5)};
  border: 0;
  border-radius: ${({ theme }) => theme.spacing(2.5)};
  background-color: ${({ isActive, theme }) =>
    isActive ? theme.colors.white : "transparent"};
  box-shadow: ${({ isActive }) =>
    isActive ? "0 1px 4px rgba(0, 0, 0, 0.14)" : "none"};
  color: ${({ theme }) => theme.colors.black};
  font-family: "Nunito", ${({ theme }) => theme.fonts.primary}, sans-serif;
  font-size: ${({ theme }) => theme.fontSizes.sm};
  white-space: nowrap;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  display: flex;

  & > svg {
    width: ${({ theme }) => theme.spacing(2.25)};
    height: ${({ theme }) => theme.spacing(2.25)};
    color: ${({ isActive, order, theme }) => {
      if (!isActive) return theme.colors.gray;
      if (order === "cheapest") return theme.colors.green;
      if (order === "best") return theme.colors.primaryColor;
      return theme.colors.yellow;
    }};
    fill: currentColor;
    flex: 0 0 auto;
  }
`;

export const ProgressTrack = styled.div`
  width: 100%;
  height: ${({ theme }) => theme.spacing(4)};
  padding: ${({ theme }) => theme.spacing(0.5)};
  border-radius: ${({ theme }) => theme.spacing(3)};
  background-color: ${({ theme }) => theme.colors.white};
  overflow: hidden;
`;

export const Progress = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== "width",
})<{ width: number }>`
  width: ${({ width }) => `${width}%`};
  height: 100%;
  border-radius: inherit;
  background-color: ${({ theme }) => theme.colors.vividBlue};
  transition: width 0.5s ease-in-out;
`;
